const ERROR_DICT = {
  config_error:
    "The widget config isn't specified. If you wanted to reinitialise Checkout Widget, make sure to use api.destroy() method.",
  iframe_creation_error: "An error occured during Checkout Widget's iframes creation.",
  iframe_internal_communication_establishment_error:
    "Widget's internal communication channels couldn't be established.",
  frontend_api_error: "Widget's frontend API couldn't be exposed.",
  unhandled_error:
    'Something went wrong during widget initialisation. If the problem continues, please reach out to our support.',
};

export function mapErrorMessageToIngridContext(e: Error) {
  switch (e.message) {
    case 'config_error':
    case 'iframe_creation_error':
    case 'iframe_internal_communication_establishment_error':
    case 'frontend_api_error':
      throw new Error(`Ingrid: Checkout Widget - ${ERROR_DICT[e.message]}`);
    default:
      throw new Error(`Ingrid: Checkout Widget - ${ERROR_DICT.unhandled_error}`);
  }
}
